// extracted by mini-css-extract-plugin
export var modalFooter = "_o0-0";